import * as React from "react";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Typography from "@material-ui/core/Typography/Typography";
import NavigationBack from '@material-ui/icons/ArrowBack';
import Home from '@material-ui/icons/Home';
import { RoutePaths } from "./route-paths";
import Input from "@material-ui/core/Input/Input";
import Search from "@material-ui/icons/Search";
import Popover from "@material-ui/core/Popover/Popover";
import { GlobalSearchResultModel } from "./model/autogen/GlobalSearchResultModel";
import { withAuthContext, IAuthContextProps } from "./components/with-auth-context";
import { SearchRequestFactory } from "./model/autogen/SearchController";
import Paper from "@material-ui/core/Paper/Paper";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { Content } from "./components/content";
import { strIsNullOrEmpty, NBSP } from "./utils/string";
import { GlobalSearchResultList, isEmptyResultSet } from "./components/global-search-result-list";
import { Iif } from "./components/iif";
import Hidden from '@material-ui/core/Hidden';
import LOGO from "./assets/labour_logo_white.svg";

export const APP_TITLE = "NZ Research Hub";

interface IInlineSearchResultsProps {
    query: string;
    results?: GlobalSearchResultModel;
}

const PAPER_POPOVER_STYLE: React.CSSProperties = {
    minWidth: 600
};

export const InlineSearchResults = (props: IInlineSearchResultsProps) => {
    const { results } = props;
    let isEmpty = false;
    if (results) {
        isEmpty = !!isEmptyResultSet(results);
    }
    return <Paper style={PAPER_POPOVER_STYLE}>
        <Content>
            <Typography variant="h5" component="h3">Search Results</Typography>
            <Iif show={!!results} else={<LinearProgress />}>
                <Iif show={!isEmpty} else={<Typography className="no-results" component="p">No results found for: <strong>{props.query}</strong></Typography>}>
                    <GlobalSearchResultList isSearchingFromHeader={true} results={results!} />
                </Iif>
            </Iif>
        </Content>
    </Paper>;
}

type HeaderProps = RouteComponentProps<any> & { title?: string } & IAuthContextProps;

interface IHeaderState {
    queryString: string;
    isSearching: boolean;
    searchResults: GlobalSearchResultModel | undefined;
}

class Header extends React.Component<HeaderProps, IHeaderState> {
    private anchorEl: any | undefined;
    constructor(props: HeaderProps) {
        super(props);
        this.state = {
            queryString: "",
            isSearching: false,
            searchResults: undefined
        }
    }
    private onKeyPress = (e: any) => {
        if (e.key == 'Enter' && !strIsNullOrEmpty(this.state.queryString)) {
            const { queryString } = this.state;
            this.anchorEl = e.currentTarget;
            this.doSearch(queryString);
        }
    }
    private onQueryStringChanged = (e: any) => {
        this.anchorEl = e.currentTarget;
        this.setState({ queryString: e.target.value });
    }
    private doSearch(queryString: string) {
        if (strIsNullOrEmpty(queryString) || strIsNullOrEmpty(queryString.trim())) {
            return;
        }
        const { callApi } = this.props;
        this.setState({
            isSearching: true,
        }, async () => {
            const results = await callApi((fetcher) => SearchRequestFactory.find(fetcher, queryString));
            this.setState({
                searchResults: results
            })
        });
    }
    private onGlobalSearch = (e: any) => {
        const { queryString } = this.state;
        this.doSearch(queryString);
    }
    private handleClose = () => {
        this.setState({
            isSearching: false,
            searchResults: undefined
        });
    }
    public render() {
        const { queryString, searchResults, isSearching } = this.state;
        const isHome = this.props.location.pathname === RoutePaths.Home;
        return <AppBar position="static" color="primary">
            <Toolbar>
                {isHome ? <></> : <Hidden smUp><IconButton className="app-back-btn" style={{ color: 'white' }} onClick={this.onLeftClick}><NavigationBack /></IconButton></Hidden>}
                {!isHome && <Hidden only={'xs'}><Link to={RoutePaths.Home}><img style={{height: '50px', marginLeft:'0' }} className="app-logo-nzl-fern" src={LOGO} /></Link></Hidden>}
                {isHome && <div><img style={{height: '50px', marginLeft:'0' }} className="app-logo-nzl-fern" src={LOGO} /></div>}
                <Typography className="app-title" variant="h6" style={{ color: 'white', flex: 1 }}>{NBSP}{this.props.title}</Typography>
                <Hidden smUp>
                    <Link to={RoutePaths.AdvancedSearch}><IconButton style={{ color: 'white' }} onClick={this.onGlobalSearch}><Search /></IconButton></Link>
                </Hidden>
                <Hidden xsDown><Input
                    style={{ color: 'white' }}
                    type="text"
                    className="app-quick-search-input"
                    placeholder="Quick Search"
                    value={this.state.queryString}
                    onChange={this.onQueryStringChanged}
                    onKeyPress={this.onKeyPress}
                    endAdornment={<IconButton style={{ color: 'white' }} onClick={this.onGlobalSearch}><Search /></IconButton>} />
                    {(() => {
                        if (isSearching && this.anchorEl) {
                            if (searchResults) {
                                return <Popover
                                    open={true}
                                    anchorEl={this.anchorEl}
                                    onClose={this.handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}>
                                    <InlineSearchResults query={queryString} results={searchResults} />
                                </Popover>;
                            } else {
                                return <Popover
                                    open={true}
                                    anchorEl={this.anchorEl}
                                    onClose={this.handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}>
                                    <InlineSearchResults query={queryString} />
                                </Popover>;
                            }
                        }
                        return undefined;
                    })()}
                </Hidden>
                {isHome ? <></> : <IconButton className="app-home-btn" style={{ color: 'white' }} onClick={this.onRightClick}><Home /></IconButton>}
            </Toolbar>
        </AppBar>;
    }

    private onLeftClick = () => {
        this.props.history.goBack();
    }
    private onRightClick = () => {
        this.props.history.push(RoutePaths.Home);
    }
}


export const HeaderWithRouter = withAuthContext(withRouter(Header));


// WEBPACK FOOTER //
// ./src/Header.tsx